import React, { useState, useEffect } from "react";
import { API } from "../constants/config";

const GD = "#D4AF37";
const BG = "#FDFBF7";

export default function DharmaRecommendCard({ query = "" }) {
  const [status, setStatus] = useState(null);
  const [data, setData]     = useState(null);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(false);

  // ── 相关性过滤：决策/冲突类查询不显示法会推荐 ──
  const _decision_keywords = ["怎么办", "冲突", "撞期", "赶不上", "去不了",
                               "能不能去", "要不要去", "去不去", "怎么办才好"];
  const _is_decision_query = query && _decision_keywords.some(kw => query.includes(kw));
  if (_is_decision_query) return null;

  useEffect(() => {
    let cancelled = false;
    const controller = new AbortController();
    const token = localStorage.getItem("lumina_token");
    const headers = token
      ? { Authorization: `Bearer ${token}` }
      : {};

    fetch(`${API}/vajra/dharma/recommend/status`, { headers, signal: controller.signal })
      .then(r => r.json())
      .then(st => {
        if (cancelled) return;
        setStatus(st);
        if (!st.can_view) { setLoading(false); return; }
        return fetch(`${API}/vajra/dharma/recommend`, { headers, signal: controller.signal })
          .then(r => r.json())
          .then(d => { if (!cancelled) setData(d); });
      })
      .catch(err => {
        if (cancelled || err.name === "AbortError") return;
        if (!cancelled) setFetchError(true);
      })
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; controller.abort(); };
  }, []);

  if (loading) return null;
  if (fetchError) return null;

  const cardStyle = {
    marginTop: 16,
    background: BG,
    border: `1px solid ${GD}44`,
    borderRadius: 12,
    padding: "16px 20px",
    fontSize: 14,
  };

  if (!status?.logged_in) {
    return (
      <div style={cardStyle}>
        <div style={{ color: GD, fontWeight: 600, marginBottom: 6 }}>
          ☸ 法会智配
        </div>
        <div style={{ color: "rgba(0,0,0,0.6)", fontSize: 13 }}>
          <a href="/vajra" style={{ color: GD }}>登录后</a>
          查看适合您命局的 BTF 教授活动 →
        </div>
      </div>
    );
  }

  if (!status?.can_view) {
    return (
      <div style={cardStyle}>
        <div style={{ color: GD, fontWeight: 600, marginBottom: 6 }}>
          ☸ 法会智配
        </div>
        <div style={{ color: "rgba(0,0,0,0.6)", fontSize: 13 }}>
          <a href="/vajra/subscribe" style={{ color: GD }}>订阅法讯</a>
          ，接收适合您命局的教授活动通知 →
        </div>
      </div>
    );
  }

  if (!data?.matched?.length) return null;

  const summary = data.user_bazi_summary;

  return (
    <div style={cardStyle}>
      <div style={{ color: GD, fontWeight: 600, marginBottom: 8, fontSize: 15 }}>
        ☸ 法会智配
      </div>

      {summary && (
        <div style={{
          fontSize: 12, color: "rgba(0,0,0,0.45)", marginBottom: 10,
          display: "flex", gap: 12, flexWrap: "wrap",
        }}>
          <span>日主 {summary["日主"]}</span>
          <span>·</span>
          <span>{summary["强弱"]}</span>
          <span>·</span>
          <span>用神 {summary["用神"]}</span>
        </div>
      )}

      {data.matched.map((item, i) => (
        <div
          key={item.series_id}
          style={{
            marginBottom: i < data.matched.length - 1 ? 12 : 0,
            paddingBottom: i < data.matched.length - 1 ? 12 : 0,
            borderBottom: i < data.matched.length - 1 ? "1px solid #e8e0ce" : "none",
          }}
        >
          <div style={{ fontWeight: 600, color: "rgba(0,0,0,0.82)", marginBottom: 2 }}>
            {item.title_zh}
            {item.karma && (
              <span style={{
                marginLeft: 8, fontSize: 11, color: GD,
                border: `1px solid ${GD}66`, borderRadius: 4,
                padding: "1px 5px",
              }}>
                {item.karma}
              </span>
            )}
          </div>
          {item.teacher_zh && (
            <div style={{ fontSize: 12, color: "rgba(0,0,0,0.5)", marginBottom: 4 }}>
              {item.teacher_zh}
            </div>
          )}
          <div style={{ fontSize: 12, color: "rgba(0,0,0,0.6)", marginBottom: 6 }}>
            {item.match_reason}
          </div>
          {item.next_event && (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: 12, color: "rgba(0,0,0,0.45)" }}>
                下次：{item.next_event.start_date}
                {item.next_event.start_time ? ` ${item.next_event.start_time}` : ""}
              </span>
              {item.next_event.slug && (
                <a
                  href={`/vajra/events/${item.next_event.slug}`}
                  style={{
                    fontSize: 12, color: GD, textDecoration: "none",
                    border: `1px solid ${GD}66`, borderRadius: 4,
                    padding: "2px 8px",
                  }}
                >
                  查看详情 →
                </a>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
